export const RESET_CONFIG_STATE = "RESET_CONFIG_STATE";

export const ADD_NEW_NOTIFICATION = "ADD_NEW_NOTIFICATION";
export const CLOSE_NOTIFICATION = "CLOSE_NOTIFICATION";

export const SET_STREAM_VIDEO_LOADING = "SET_STREAM_VIDEO_LOADING";

export const SET_LIST_DIALOG_CONFIG = "SET_LIST_DIALOG_CONFIG";
